import axios from 'axios';

// This instance won't have interceptors from global app config
const rawAxios = axios.create();

export default rawAxios;